import styled from 'styled-components'

export const NAME_COLUMN_WIDTH = 300
export const NUMBER_COLUMN_WIDTH = 120
export const DATE_COLUMN_WIDTH = 160
export const OPTIONS_COLUMN_WIDTH = 45

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

/** Tab bar only. The list stays below, so the pane slide does not push it off screen. */
export const StatusTabs = styled.div`
  .ant-tabs-content {
    display: none;
  }
`

export const Title = styled.h1`
  margin: 0;
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  color: #002a6d;
`

export const NameCell = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  max-width: ${NAME_COLUMN_WIDTH}px;
`

export const Name = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
  color: #363636;
`

export const Description = styled.span`
  white-space: normal;
  font-size: 12px;
  line-height: 16px;
  color: #757575;
`

export const TableContainer = styled.div`
  width: 100%;
`
